import React, { useState, useEffect } from "react";
import { inputStyles } from "./styles/inputStyles";
import { useIntl } from "react-intl";
import { TextField } from "@mui/material";
import SearchLoadSkeleton from "../../Skeletons/SearchLoadSkeleton";
// import ClearInputButton from "../../Buttons/ClearInputButton";

const MeetingClientSearch = ({
    clients,
    selectedClient,
    setSelectedClient,
    setSuggestions,
    eventData,
    setEventData,
    isLoading,
    clientError,
    setClientError,
    selectedMeetingTypeData,
    meetingTypes,
    setHasChanges,
}) => {
    const [filteredClients, setFilteredClients] = useState([]);
    const [showSuggestions, setShowSuggestions] = useState(false);
    const [isClientMandatory, setIsClientMandatory] = useState(false);

    const intl = useIntl();

    useEffect(() => {
        if (selectedMeetingTypeData) {
            setIsClientMandatory(selectedMeetingTypeData.is_client_mandatory);
        }
    }, [selectedMeetingTypeData]);

    useEffect(() => {
        if (eventData.client) {
            setShowSuggestions(false);
            setClientError(false); // Clear error when client ID exists
        }

        const findMT = [...meetingTypes].filter(
            (type) => type.meeting_type_id === eventData.meeting_type_id
        );

        if (findMT.length > 0) {
            const isMandatory = findMT[0].is_client_mandatory;

            if (isMandatory && eventData.client === null) {
                setIsClientMandatory(true);
            } else if (!isMandatory) {
                setClientError(false);
            } else {
                setIsClientMandatory(isMandatory);
                setClientError(false);
            }
        }
    }, [eventData.client, meetingTypes, eventData.meeting_type_id]);

    useEffect(() => {
        if (selectedClient === "") {
            setFilteredClients([]);
        } else {
            const filtered = clients
                .filter((client) => client.is_active) // Filter active clients
                .filter((client) =>
                    client.client_name
                        .toLowerCase()
                        .includes(selectedClient.toLowerCase())
                );
            setFilteredClients(filtered);
        }
    }, [selectedClient, clients, isLoading]);

    // Function to handle selecting a suggestion
    const handleSelectSuggestion = (client) => {
        setEventData((prevData) => ({
            ...prevData,
            client: client,
        }));
        setHasChanges(true);
        setSelectedClient(client.client_name);
        setSuggestions([]); // Hide suggestions after selection
    };

    // const resetSuggestion = () => {
    //     setEventData((prevData) => ({
    //         ...prevData,
    //         client: null,
    //     }));
    //     setHasChanges(true);
    //     setSelectedClient("");
    //     setSuggestions([]);
    //     setClearAddress(true);
    // };

    const placeholder = isClientMandatory
        ? intl.formatMessage({
              id: "meetingModal.addClientMandatory",
          })
        : intl.formatMessage({
              id: "meetingModal.addClient",
          });

    return (
        <div className="relative flex flex-col md:flex-row w-full">
            <TextField
                variant="filled"
                fullWidth
                value={selectedClient}
                onChange={(e) => {
                    setEventData((prevData) => ({
                        ...prevData,
                        client: null,
                    }));
                    setSelectedClient(e.target.value);
                    setShowSuggestions(true);
                }}
                error={clientError}
                helperText={
                    clientError
                        ? intl.formatMessage({ id: "meetingModal.clientError" })
                        : ""
                }
                label={placeholder}
                onBlur={() => setShowSuggestions(false)} // Hide suggestions on blur
                onFocus={() => setShowSuggestions(true)} // Show suggestions on focus
                sx={inputStyles}
            />
            {/* {selectedClient != "" && (
                <ClearInputButton action={resetSuggestion} />
            )} */}
            {/* Show suggestions if any clients match the search term */}
            {showSuggestions && filteredClients.length > 0 && (
                <div className="absolute top-full w-full bg-white border border-slate-300 rounded-lg shadow-lg max-h-60 overflow-y-auto no-scrollbar z-10 text-left">
                    {filteredClients.map((client) => (
                        <div
                            key={client.client_id}
                            onMouseDown={(e) => {
                                e.preventDefault(); // Prevent any unwanted behavior
                                handleSelectSuggestion(client);
                            }}
                            className="cursor-pointer px-3 py-2 hover:bg-gray-100"
                        >
                            <div className="flex flex-row items-center h-full">
                                <div className="text-base text-black w-2/3 font-medium ">
                                    {client.client_name},{" "}
                                    <span className="italic text-sm text-gray-700">
                                        {client.city}
                                    </span>
                                </div>
                                <div className="ml-5 text-base text-gray-700 w-1/3">
                                    ID:{client.client_id}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            )}
            {showSuggestions &&
                selectedClient.length > 0 &&
                filteredClients.length === 0 &&
                !isLoading && (
                    <div className="absolute top-full w-full bg-white border border-slate-300 rounded-lg shadow-lg min-h-10 max-h-60 overflow-y-auto mt-2 z-10 text-center text-gray-500 flex items-center justify-center">
                        {intl.formatMessage({
                            id: "meetingModal.noClientsFound",
                            defaultMessage: "Aucun client trouvé",
                        })}
                    </div>
                )}
            {showSuggestions &&
                selectedClient.length > 0 &&
                filteredClients.length === 0 &&
                isLoading && <SearchLoadSkeleton />}
        </div>
    );
};

export default MeetingClientSearch;
